import { render, staticRenderFns } from "./EventosRecebidos.vue?vue&type=template&id=2a91f226&scoped=true"
import script from "./EventosRecebidos.vue?vue&type=script&lang=js"
export * from "./EventosRecebidos.vue?vue&type=script&lang=js"
import style0 from "./EventosRecebidos.vue?vue&type=style&index=0&id=2a91f226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91f226",
  null
  
)

export default component.exports